export default "__VITE_ASSET__C7jHUIs6__"